import SolverPage from '../../components/layout/SolverPage'

const Solver = () => {
  return <SolverPage />
}

export default Solver
